export const locale = {
    lang: 'en',
    data: {
        APP_SWITCHER: {
            PERSONEL_MANAGEMENT: 'PERSONEL MANAGEMENT',
            ACCOUNTANT: 'ACCOUNTANT'
        }
    }
};
